import { render, staticRenderFns } from "./FolderDetail.vue?vue&type=template&id=221ebb70&scoped=true"
import script from "./FolderDetail.vue?vue&type=script&lang=js"
export * from "./FolderDetail.vue?vue&type=script&lang=js"
import style0 from "./FolderDetail.vue?vue&type=style&index=0&id=221ebb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221ebb70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VMenu,VSkeletonLoader})
